import main from './main.vue'
const commonHeader= {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
// 导出该组件
export default commonHeader